import {Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useTheme} from "@mui/material/styles";


const StateContainer = ({ label, children }) => {
  return (
    <Accordion
      defaultExpanded={true}
      disableGutters={true}
      variant={'primary'}
      sx={{width: '100%'}}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{color: '#FEFEFF'}}/>}
      >
        <Typography
          fontSize={14}
          color={'text.light'}
        >
          {label}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{
        padding: '2px'
      }}>
        <Box sx={{
          border: '1px solid #c5c5c5',
          p: 1,
          borderRadius: '8px',
          bgcolor: 'rgb(222,224,231)',
        }}>
          {children}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export default StateContainer;